// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const farfetchd: PokeData = {
  "id": 83,
  "name": "farfetchd",
  "height": 8,
  "weight": 150,
  "base_experience": 132,
  "types": [
    PokeType.NORMAL,
    PokeType.FLYING
  ],
  "api_moves": [
    "swords-dance",
    "cut",
    "sand-attack",
    "fury-attack",
    "leer",
    "peck",
    "razor-leaf",
    "agility",
    "quick-attack",
    "focus-energy",
    "mirror-move",
    "sky-attack",
    "slash",
    "false-swipe",
    "fury-cutter",
    "knock-off",
    "air-cutter",
    "aerial-ace",
    "leaf-blade",
    "feint",
    "poison-jab",
    "night-slash",
    "air-slash",
    "brave-bird",
    "acrobatics"
  ],
  "moves": [
    "leer",
    "peck",
    "razor-leaf",
    "quick-attack",
    "sky-attack",
    "aerial-ace",
    "poison-jab",
    "night-slash",
    "air-slash",
    "brave-bird",
    "acrobatics",
    "tailwind",
    "protect"
  ],
  "evolution_chain": {
    "id": 35,
    "item": null,
    "species": [
      {
        "name": "farfetchd",
        "order": 91,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sirfetchd",
        "order": 865,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 83,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.THREE_CRITICAL_HITS
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 55.25,
    "speed": 60,
    "ability_power": 90
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
